const sx = {
  root: {
    flexShrink: 0,
    lineHeight: 0,
    pointerEvents: 'none',
    // El SVG que inyecta lottie ocupa el contenedor por completo.
    '& svg': {
      display: 'block',
      width: '100%!important',
      height: '100%!important',
    },
  },
}

export default sx
